function stickyActionBar() {
  const addToCartBtn = document.querySelector('.product-form__submit');
  const stickyAddToCartBtn = document.querySelector(
    '.product__sticky-actionBar__addToCart-btn',
  );
  const variantSelectorWrapper = document.querySelector(
    '.product__variant-selector-wrapper',
  );
  const productTitle = document.querySelector('.product__title-main h1');
  const stickyProductTitle = document.querySelector(
    '.product__stickey-actionBar__title',
  );
  const productRegularPrice = document.querySelector(
    '.product__titleXprice .price-item--regular',
  );
  const productSalePrice = document.querySelector(
    '.product__titleXprice .price-item--sale',
  );
  const stickyProductPrice = document.querySelector(
    '.product__stickey-actionBar__price',
  );
  const productOptionWrappers = document.querySelectorAll(
    '.product__custom-selector-wrapper',
  );
  const stickyOptionCont = document.querySelector(
    '.product__sticky-actionBar__option-container',
  );
  const stickyActionBarCont = document.querySelector(
    '.product__sticky-actionBar-wrapper',
  );

  // COB2B-652: volume UI replaces single price/qty with per-row controls,
  // so price sync from .product__titleXprice has nothing to mirror.
  const volumeUiActive = !!document.querySelector(
    '.product__volume-variants',
  );

  // sync add to cart button click
  function syncAddToCartBtnClick(originalBtn, stickyBtn) {
    if (originalBtn && stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        originalBtn.click();
      });
    }
  }
  syncAddToCartBtnClick(addToCartBtn, stickyAddToCartBtn);

  // sync add to cart button status
  function syncAddToCartBtnStatus(originalBtn, stickyBtn) {
    if (originalBtn && stickyBtn) {
      if (
        originalBtn.getAttribute('disabled') == 'disabled' ||
        originalBtn.disabled == true
      ) {
        stickyBtn.disabled = true;
        stickyBtn.textContent = 'SOLD OUT';
      } else {
        stickyBtn.disabled = false;
        stickyBtn.textContent = 'ADD TO BAG';
      }
    }
  }
  window.addEventListener('load', () => {
    syncAddToCartBtnStatus(addToCartBtn, stickyAddToCartBtn);
  });
  variantSelectorWrapper?.addEventListener('change', () => {
    setTimeout(() => {
      syncAddToCartBtnStatus(addToCartBtn, stickyAddToCartBtn);
    }, 1500);
  });

  // sync title
  function syncTitle(originalTitle, stickyTitle) {
    if (originalTitle && stickyTitle) {
      const index = originalTitle.textContent.indexOf('-');
      const modifiedTitle = originalTitle.textContent
        .slice(0, index - 1)
        .trim();
      stickyTitle.textContent = modifiedTitle;
    }
  }
  syncTitle(productTitle, stickyProductTitle);

  // sync price
  function syncPrice(originalRegularPrice, originalSalePrice, stickyPrice) {
    if (originalRegularPrice && originalSalePrice && stickyPrice) {
      let productPrice = null;
      if (originalRegularPrice.style.display == 'none') {
        productPrice = originalSalePrice.textContent.trim();
      } else {
        productPrice = originalRegularPrice.textContent.trim();
      }
      stickyPrice.textContent = productPrice;
    }
  }
  if (!volumeUiActive) {
    syncPrice(productRegularPrice, productSalePrice, stickyProductPrice);
    variantSelectorWrapper?.addEventListener('change', () => {
      setTimeout(() => {
        syncPrice(productRegularPrice, productSalePrice, stickyProductPrice);
      }, 1500);
    });
  }

  // populate options
  function populateOptions(productOptions, stickyOptionContainer) {
    if (productOptions && stickyOptionContainer) {
      productOptions.forEach((option, index) => {
        const stickyOption = document.createElement('div');
        stickyOption.classList.add('product__sticky-actionBar__option');
        stickyOption.classList.add(
          `product__sticky-actionBar__option--${index}`,
        );
        stickyOptionContainer.insertAdjacentElement('afterbegin', stickyOption);

        const selectedOption = document.querySelector(
          `.product__custom-selector-wrapper--${index + 1} .product__custom-selector__main-selected-value`,
        );
        if (!selectedOption) return;
        stickyOption.textContent = selectedOption.textContent
          .toLowerCase()
          .replace('size', '')
          .trim()
          .toUpperCase();
        if (selectedOption.textContent.toLowerCase().includes('size')) {
          stickyOption.classList.add(`product__sticky-actionBar__option--size`);
          stickyOption.textContent = `S${stickyOption.textContent}`;
        }
      });
    }
  }
  populateOptions(productOptionWrappers, stickyOptionCont);

  // sync options
  function syncOptions(vaiantSelector, productOptions) {
    if (vaiantSelector && productOptions) {
      vaiantSelector.addEventListener('change', (e) => {
        setTimeout(() => {
          productOptions.forEach((option, index) => {
            const selectedOption = option.querySelector(
              '.product__custom-selector__main-selected-value',
            );
            const stickyOption = document.querySelector(
              `.product__sticky-actionBar__option--${index}`,
            );
            if (!selectedOption || !stickyOption) return;
            stickyOption.textContent = selectedOption.textContent
              .toLowerCase()
              .replace('size', '')
              .trim()
              .toUpperCase();
            if (selectedOption.textContent.toLowerCase().includes('size')) {
              stickyOption.textContent = `S${stickyOption.textContent}`;
            }
          });
        }, 1500);
      });
    }
  }
  syncOptions(variantSelectorWrapper, productOptionWrappers);

  // show and hide sticky action bar
  function showHideStickyActionBar(referenceElem, targetElem) {
    if (referenceElem && targetElem) {
      window.addEventListener('scroll', () => {
        const gap = referenceElem.getBoundingClientRect().top;
        if (gap < -30) {
          targetElem.style.display = 'block';
        } else {
          targetElem.style.display = 'none';
        }
      });
    }
  }
  showHideStickyActionBar(addToCartBtn, stickyActionBarCont);
}

export { stickyActionBar as default };
